import $ from 'jquery';

function PlayPauseControls(element) {
  this.element = element;
  this.$element = $(element);
  this.addControls = this.addControls.bind(this);
  this.play = this.play.bind(this);
  this.pause = this.pause.bind(this);
  this.addControls();
  this.addListeners();
}

PlayPauseControls.prototype = {
  addControls() {
    this.$element.append('<div class="video-controls"><div class="video-controls-wrapper"><button class="vid-play active">Play</button><button class="vid-pause">Pause</button></div></div>');
  },
  play(event) {
    event.preventDefault();
    this.$element.find('video')[0].play();
    $(event.target).addClass('active').siblings().removeClass('active');
  },
  pause(event) {
    event.preventDefault();
    this.$element.find('video')[0].pause();
    $(event.target).addClass('active').siblings().removeClass('active');
  },
  addListeners() {
    this.$element.find('.vid-play').on('click', this.play);
    this.$element.find('.vid-pause').on('click', this.pause);
  },
};

export default PlayPauseControls;
